__turbopack_context__.v({
  "container": "IndustryHero-module__UsvOVW__container",
  "embeddedForm": "IndustryHero-module__UsvOVW__embeddedForm",
  "formAnchor": "IndustryHero-module__UsvOVW__formAnchor",
  "hero": "IndustryHero-module__UsvOVW__hero",
  "heroCopy": "IndustryHero-module__UsvOVW__heroCopy",
  "heroCta": "IndustryHero-module__UsvOVW__heroCta",
  "heroFormCard": "IndustryHero-module__UsvOVW__heroFormCard",
  "heroGrid": "IndustryHero-module__UsvOVW__heroGrid",
  "heroImageOverlay": "IndustryHero-module__UsvOVW__heroImageOverlay",
  "heroImagePrimary": "IndustryHero-module__UsvOVW__heroImagePrimary",
  "heroImageStack": "IndustryHero-module__UsvOVW__heroImageStack",
  "heroSubtitle": "IndustryHero-module__UsvOVW__heroSubtitle",
  "heroTitle": "IndustryHero-module__UsvOVW__heroTitle",
  "ratingStars": "IndustryHero-module__UsvOVW__ratingStars",
  "ratingText": "IndustryHero-module__UsvOVW__ratingText",
  "star": "IndustryHero-module__UsvOVW__star",
});
